export const GAME = 'game';
export const BETS = 'bets';
export const BETS_MOBILE = 'betsMobile';
export const MY_BETS = 'myBets';
export const CHAT = 'chat';
export const LEADER_BOARD = 'leaderBoard';
export const TOURNAMENTS = 'tournaments';
export const PROFILE = 'profile';
